<template>
    <div class="default-message">

        <span v-html="$t('message.hint_menu_bell1')"></span>
        <br>
        <hr class="hint-hr">
        <br>

        <table class="hint-table" align="center" >
            <tr>
                <td class="hint-table-title" v-t="'message.item_bell'"></td>
            </tr>
            <tr>
                <td class="hint-table-item" v-html="$t('message.hint_menu_bell2')">
                </td>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
    data() {
      return {
      };
    },
    methods: {
    },
    components: {
    },
    props: ['appData']
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
